<template>
  <div class="personal-mine">
    <component :is="taskModeCheck.components" :uid="uid" ref="list" @taskClick="taskClick" @projectClick="projectClick" :onlyReal="onlyReal" v-bind="$props" @nothing="data => isNothing = data"></component>
  </div>
</template>
<script>
import api from '@/services/api/mine/mine'
import { mapMutations, mapState } from 'vuex'
import bus from '@/bus'
import Gantt from './gantt'
import ListView from './listView'
export default {
  props: ['uid', 'onlyReal'],
  components: {
    Gantt,
    ListView
  },
  data() {
    return {
      isNothing: true
    }
  },
  computed: {
    ...mapState('mine/mine', {
      taskModeCheck: state => state.taskModeCheck
    })
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    ...mapMutations('task/task', ['CHANGE_TASK']),
    taskClick({ task_id, task_list_id }) {
      this.CHANGE_TASK({ visible: true, task_id, task_list_id })
    },
    projectClick(project_id) {
      this.$router.push(`/task?projectId=${project_id}&isTabShow=true`)
    }
  }
}
</script>
<style lang="scss">
.personal-mine {
  height: 0;
  flex: 1;
  .my-select-value .select-box-content---hidden {
    background-color: #fff;
  }
  .el-dropdown-link {
    display: inline-block;
    height: auto;
    padding: 0;
  }
  .filter-box {
    padding: 0 24px;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      width: 400px;
    }
    .right {
      display: flex;
      align-items: center;
      .list-checkbox {
        margin-right: 32px;
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #2682ff;
          border-color: #2682ff;
        }
      }
      .el-checkbox__label {
        color: rgba(32, 32, 32, 0.6);
        font-weight: normal;
      }
      .list-model {
        border-radius: 4px;
        border: 1px solid rgba(32, 32, 32, 0.16);
        height: 32px;
        margin-left: 24px;
        display: flex;
        &:hover {
          i {
            color: #2682ff;
          }
        }
        &:active {
          i {
            color: #0463d6;
          }
        }
        i {
          display: inline-block;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          color: rgba(32, 32, 32, 0.6);
          cursor: pointer;
        }
        i:first-child {
          border-right: 1px solid rgba(32, 32, 32, 0.16);
        }
        .check {
          color: $color-active;
        }
      }
    }
    .top-search {
      .el-input__icon {
        line-height: 32px;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .personal-mine-handle {
    display: flex;
    justify-content: center;
    .nothing {
      width: 981px;
      margin-top: 24px;
    }
    .list {
      flex: 3;
      box-sizing: border-box;
      width: 100%;
    }
    .detail {
      position: relative;
      flex: 2;
      height: 100%;
    }
    .content {
      display: flex;
      width: 100%;
      height: 100%;
    }

    .list-task {
      overflow: hidden;
      margin-bottom: 12px;
    }
    .list-task-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      height: 64px;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      i {
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        transition: all .3s;
        color: rgba(32, 32, 32, 0.24);
      }
      > div:first-child {
        font-size: 12px;
        color: rgba(32, 32, 32, 0.6);
        span {
          font-size: 16px;
          color: initial;
          font-weight: bold;
          margin: 0 8px 0 4px;
        }
      }
      > div:last-child {
        font-size: 14px;
        color: rgba(32, 32, 32, 0.6);
        cursor: pointer;
        span {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
